import { Box, Paper, Chip } from "@mui/material";
import { Typography } from "@mui/material";
import {
  getAllPermitsInPackage,
  getPermitStructureInfo,
} from "../../permitForms/permitFormHelpers";
import { pipeline_tree } from "../../../data/city_sites/permitTypesTree";
import { useSelector } from "react-redux";

const BasePermitCard = () => {
  const selectedRow = useSelector(
    (state) => state.myPermitsComponent.selectedRow
  );
  const selectedPermitType = useSelector(
    (state) => state.myPermitsComponent.selectedPermitType
  );

  const allPermits = getAllPermitsInPackage(selectedRow, selectedPermitType);
  const structureInfo = getPermitStructureInfo(selectedRow, pipeline_tree);

  const basePermit = allPermits.find((p) => p.isBase);
  return (
    <Box>
      {/* Base Permit Display */}

      <Paper
        elevation={2}
        sx={{
          p: 2,
          mb: 3,
          backgroundColor: "#f8f9fa",
          border: "2px solid #28a745",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <Chip
            label="Base Permit"
            color="success"
            variant="filled"
            sx={{ fontWeight: "bold" }}
          />
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" fontWeight="bold">
              {basePermit.name}
            </Typography>
            <Typography variant="h5" color="primary" fontWeight="bold">
              {basePermit.permitNumber}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {basePermit.isConnectedToCity
                ? "City Connected"
                : "Not Connected"}
            </Typography>

            {/* Display Proposed Use and Structure Type */}
            {(structureInfo.proposedUseTitle ||
              structureInfo.structureTypeTitle) && (
              <Box sx={{ mt: 1, pt: 1, borderTop: "1px solid #e0e0e0" }}>
                {structureInfo.proposedUseTitle && (
                  <Typography variant="body2" color="text.secondary">
                    <strong>Proposed Use:</strong>{" "}
                    {structureInfo.proposedUseTitle}
                  </Typography>
                )}
                {structureInfo.structureTypeTitle && (
                  <Typography variant="body2" color="text.secondary">
                    <strong>Structure Type:</strong>{" "}
                    {structureInfo.structureTypeTitle}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default BasePermitCard;
